import { Grid, Typography } from "@mui/material";
import React, { FC } from "react";
import { Pie } from "react-chartjs-2";
import { IClubProposals } from "../../common/interfaces/club.interface";
import {
  generateProposalStatusPieData,
  generateProposalTypePieData,
  getProposalMaxVotingTime,
} from "../../utils/helpers";
import AppCard from "../cards/AppCard";
import classes from "./ClubProposals.module.scss";

const ClubProposals: FC<{ proposalsOverview: IClubProposals }> = ({
  proposalsOverview,
}) => {
  return (
    <div className={classes.proposalsOverview}>
      <Typography variant="subtitle1" my={1}>
        Proposals
      </Typography>
      <Grid
        container
        spacing={{ xs: 1, md: 2, sm: 2 }}
        columns={{ xs: 3, sm: 8, md: 10 }}
      >
        <Grid
          item
          container
          xs={12}
          sm={12}
          md={5}
          direction={"column"}
          gap={2}
        >
          <AppCard
            label={"Total number of proposals"}
            value={proposalsOverview.total.toString()}
          />
          <AppCard
            label={"Max voting time"}
            value={`${getProposalMaxVotingTime(
              proposalsOverview.maxVotingTime
            )} days`}
          />
          <AppCard
            label={"Defailt approval quorum"}
            value={proposalsOverview.defaultApprovalQuorum.toString()}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={5.5}>
          <Grid
            container
            spacing={{ xs: 2, md: 3, sm: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            paddingTop={2}
            justifyContent="start"
            alignItems="start"
          >
            <Grid item xs={12} sm={12} md={6}>
              <Pie data={generateProposalStatusPieData(proposalsOverview)} />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <Pie data={generateProposalTypePieData(proposalsOverview)} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ClubProposals;
